import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { FieldComponents } from './FieldRegistry';

export const SchemaRenderer = ({ basePath, fields }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%',
      }}
    >
      {fields?.map((field) => {
        const Component = FieldComponents[field.type];

        if (!Component) {
          console.warn(`Unsupported field type: ${field.type}`);
          return null;
        }
        return <Component key={field.key} basePath={basePath} field={field} />;
      })}
    </Box>
  );
};
